import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import {
  EtcOutboundConfirmBody,
  EtcOutboundConfirmRes,
  EtcOutboundSaveBody,
  EtcOutboundSaveRes,
  EtcOutboundSearchBody,
  EtcOutboundSearchRes,
  OutboundProgress,
} from '@/services/outbound/outboundEtc/types'

// 1.0 GI35 도 같은 API 를 헤더 없이 부른다 — BE 는 X-Menu-Code 가 GI38 일 때만 감사 로그를 남긴다(LOGISPRD-16047)
const GI38_HEADERS = menuCodeHeaders('GI38')

/**
 * 기타출고 조회. moms-be `OutboundEtcController.searchEtcOutbounds`.
 *
 * 본문이 `{ params: "<JSON 문자열>" }` 인 건 오타가 아니다 — BE `EtcOutboundSearchRequest.params`
 * 가 String 이고 안에서 다시 파싱한다(1.0 계약 유지). 평문 객체로 보내면 400 이 난다.
 */
export const getEtcOutbounds = (body: EtcOutboundSearchBody) =>
  request.post<EtcOutboundSearchRes, GridApiRequestBody>('/api/v1/get-etc-outbounds', { params: JSON.stringify(body) }, GI38_HEADERS)

/**
 * 기타출고 저장. moms-be `OutboundEtcController.saveEtcOutbound`.
 *
 * 조회와 같은 이유로 본문이 `{ data: "<JSON 문자열>" }` 이다.
 * 성공(200)이면 `progressKey` 로 진행률을 폴링하고, 중복 주문이면 400 + `dupCheck`,
 * SKU 미해소면 422 + `failedBarcodes` 로 온다. 400·422 는 axios 가 reject 하므로 호출부가 받는다.
 */
export const saveEtcOutbounds = (body: EtcOutboundSaveBody) =>
  request.post<EtcOutboundSaveRes, { data: string }>('/api/v1/save-etc-outbounds', { data: JSON.stringify(body) }, GI38_HEADERS)

/**
 * 기타출고 확정. moms-be `OutboundEtcController.confirmEtcOutbounds`.
 * 여기만 평문 JSON 본문이다(BE 가 `@RequestBody @Valid` 로 직접 받는다).
 */
export const confirmEtcOutbounds = (body: EtcOutboundConfirmBody) =>
  request.post<EtcOutboundConfirmRes, EtcOutboundConfirmBody>('/api/v1/confirm-etc-outbounds', body, GI38_HEADERS)

/** 저장 진행률. moms-be `OutboundProgressController`. 2.0 표준 응답(StandardResponse)이다. */
export const getOutboundProgress = (progressKey: string) =>
  request.get<ApiResponseV2<OutboundProgress | null>>(`/api/v1/outbound-progress/${encodeURIComponent(progressKey)}`)
